// Data test IDs for school components
// Centralized enums grouped by component to ensure consistency and prevent typos

export enum schoolCardTestIds {
  SCHOOL_CARD = "school-card",
  SCHOOL_CARD_CONTENT = "school-card-content",
  SCHOOL_CARD_FOOTER = "school-card-footer",
}

export enum schoolHeaderTestIds {
  SCHOOL_HEADER = "school-header",
  SCHOOL_NAME = "school-name",
  SCHOOL_DISTRICT = "school-district",
  SCHOOL_ADDRESS = "school-address",
  SCHOOL_PRINCIPAL = "school-principal",
  SCHOOL_PRINCIPAL_NAME = "school-principal-name",
}

export enum schoolStatsTestIds {
  SCHOOL_STUDENT_COUNT = "school-student-count",
  SCHOOL_TYPE = "school-type",
  SCHOOL_LOCATION = "school-location",
  SCHOOL_DISTANCE_FROM_LOCATION = "school-distance-from-location",
}

export enum schoolGradesTestIds {
  SCHOOL_GRADES = "school-grades",
  GRADE_GROUP_ELEMENTARY = "grade-group-elementary",
  GRADE_GROUP_MIDDLE = "grade-group-middle",
  GRADE_GROUP_HIGH = "grade-group-high",
  DISTRICT_SALARIES_LINK = "district-salaries-link",
}

export enum schoolTagsTestIds {
  SCHOOL_TAGS = "school-tags",
  SCHOOL_TAG_ITEM = "school-tag-item",
}

export enum schoolJobPostingsTestIds {
  SCHOOL_JOB_POSTINGS = "school-job-postings",
  SCHOOL_JOB_COUNT = "school-job-count",
  SCHOOL_JOB_LIST = "school-job-list",
  SCHOOL_JOB_ITEM = "school-job-item",
  SCHOOL_MORE_JOBS = "school-more-jobs",
  SCHOOL_NO_JOBS_MESSAGE = "school-no-jobs-message",
}

export enum schoolCardActionsTestIds {
  SCHOOL_CARD_ACTIONS = "school-card-actions",
  SCHOOL_CARD_VIEW_DETAILS_BUTTON = "school-card-view-details-button",
  SCHOOL_CARD_SHARE_BUTTON = "school-card-share-button",
  SCHOOL_CARD_SALARY_INFO_BUTTON = "school-card-salary-info-button",
  SCHOOL_CARD_GET_DIRECTIONS_BUTTON = "school-card-get-directions-button",
  SCHOOL_CARD_EXPRESS_INTEREST_BUTTON = "school-card-express-interest-button",
  SCHOOL_CARD_SAVE_SCHOOL_BUTTON = "school-card-save-school-button",
}

export enum schoolPageSidebarTestIds {
  CONNECT_PROMPT = "school-page-sidebar-connect-prompt",
}

export enum schoolPageHeaderActionsTestIds {
  SCHOOL_PAGE_HEADER_ACTIONS = "school-page-header-actions",
  SCHOOL_PAGE_HEADER_SAVE_SCHOOL_BUTTON = "school-page-header-save-school-button",
  SCHOOL_PAGE_HEADER_GET_ALERTS_BUTTON = "school-page-header-get-alerts-button",
  SCHOOL_PAGE_HEADER_SHARE_SCHOOL_BUTTON = "school-page-header-share-school-button",
}

export enum schoolQuickApplyTag {
  QUICK_APPLY_TAG_ELEMENT = "school-quick-apply-tag-element",
}

export enum aboutThisSchoolTestIds {
  ABOUT_THIS_SCHOOL = "about-this-school",
  ABOUT_THIS_SCHOOL_PRINCIPAL = "about-this-school-principal",
  ABOUT_THIS_SCHOOL_LOCATION = "about-this-school-location",
  ABOUT_THIS_SCHOOL_GRADES = "about-this-school-grades",
  ABOUT_THIS_SCHOOL_STUDENTS = "about-this-school-students",
  ABOUT_THIS_SCHOOL_TYPE = "about-this-school-type",
}

export enum schoolDetailsPaginationTestIds {
  PREV_BUTTON = "school-details-pagination-prev",
  NEXT_BUTTON = "school-details-pagination-next",
}

export enum schoolDetailsNavTestIds {
  BACK_TO_SEARCH_BUTTON = "school-details-back-to-search",
}

export enum savedSchoolsTestIds {
  PAGE = "saved-schools-page",
  COUNT = "saved-schools-count",
  LIST = "saved-schools-list",
  EMPTY_STATE = "saved-schools-empty-state",
}

export enum savedSchoolsPaginationTestIds {
  PREV_BUTTON = "saved-schools-pagination-prev",
  NEXT_BUTTON = "saved-schools-pagination-next",
}

// Combined school test IDs object for easier importing
export const schoolTestIds = {
  ...schoolCardTestIds,
  ...schoolHeaderTestIds,
  ...schoolStatsTestIds,
  ...schoolGradesTestIds,
  ...schoolTagsTestIds,
  ...schoolJobPostingsTestIds,
  ...schoolCardActionsTestIds,
  ...schoolPageHeaderActionsTestIds,
} as const;
